<template>
  <el-dialog
      title="预审核失败原因"
      :visible="dialogVisible"
      width="650px"
      @close="dialogVisible = false"
      :close-on-click-modal="false"
      center
  >
    <p>{{formData.pretrialRemark}}</p>
    <div slot="footer">
      <el-button size="medium" type="info" @click="dialogVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  data() {
    return {
      dialogVisible: false,
      formData: {
        pretrialRemark:''
      }
    };
  },
  methods: {
    showDialog(row) {
      console.log(row);
      this.dialogVisible = true
      this.formData = row
    },
  }
};
</script>

<style lang="scss" scoped>

</style>
